/* NexTap marketing site — vanilla JS only (Shopify Liquid theme friendly).
   No build step, no framework. Each block is independent and safe to drop
   into a theme as its own snippet. */
(function () {
  "use strict";

  /* Sticky header hairline */
  var header = document.querySelector("[data-nt-header]");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* Nav dropdowns — click to open, Escape or outside click to close */
  var groups = [].slice.call(document.querySelectorAll("[data-nt-dropdown]"));
  groups.forEach(function (g) {
    var trigger = g.querySelector("[data-nt-dropdown-trigger]");
    if (!trigger) return;
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      var open = g.classList.contains("is-open");
      groups.forEach(function (o) { o.classList.remove("is-open"); });
      g.classList.toggle("is-open", !open);
      trigger.setAttribute("aria-expanded", String(!open));
    });
  });
  document.addEventListener("click", function (e) {
    groups.forEach(function (g) {
      if (!g.contains(e.target)) g.classList.remove("is-open");
    });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") groups.forEach(function (g) { g.classList.remove("is-open"); });
  });

  /* Mobile drawer */
  var burger = document.querySelector("[data-nt-burger]");
  var drawer = document.querySelector("[data-nt-drawer]");
  if (burger && drawer) {
    burger.addEventListener("click", function () {
      var open = drawer.hasAttribute("hidden");
      if (open) drawer.removeAttribute("hidden"); else drawer.setAttribute("hidden", "");
      burger.setAttribute("aria-expanded", String(open));
    });
  }

  /* Accordion (FAQ) — single open at a time */
  [].forEach.call(document.querySelectorAll("[data-nt-accordion]"), function (root) {
    root.addEventListener("click", function (e) {
      var trigger = e.target.closest(".nt-accordion__trigger");
      if (!trigger) return;
      var item = trigger.parentElement;
      var wasOpen = item.classList.contains("is-open");
      [].forEach.call(root.children, function (c) { c.classList.remove("is-open"); });
      item.classList.toggle("is-open", !wasOpen);
      trigger.setAttribute("aria-expanded", String(!wasOpen));
    });
  });

  /* Tab / filter groups: [data-nt-tabs] with .nt-tag buttons + [data-nt-panel] */
  [].forEach.call(document.querySelectorAll("[data-nt-tabs]"), function (tabs) {
    var scope = document.querySelector(tabs.getAttribute("data-nt-tabs")) || document;
    tabs.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-value]");
      if (!btn) return;
      [].forEach.call(tabs.querySelectorAll("[data-value]"), function (b) {
        b.setAttribute("aria-pressed", String(b === btn));
      });
      var value = btn.getAttribute("data-value");
      [].forEach.call(scope.querySelectorAll("[data-nt-panel]"), function (p) {
        var match = value === "all" || p.getAttribute("data-nt-panel") === value;
        p.style.display = match ? "" : "none";
      });
    });
  });

  /* Logo upload: [data-nt-drop] wraps a file input, shows the chosen filename
     and accepts drag-and-drop. The native input stays in the DOM (hidden by
     CSS opacity) so Shopify still receives properties[Logo] on submit. */
  [].forEach.call(document.querySelectorAll("[data-nt-drop]"), function (drop) {
    var input = drop.querySelector('input[type="file"]');
    if (!input) return;
    var nameEl = drop.querySelector("[data-nt-drop-name]");
    var sizeEl = drop.querySelector("[data-nt-drop-size]");

    var show = function () {
      var file = input.files && input.files[0];
      drop.classList.toggle("is-filled", !!file);
      if (!file) return;
      if (nameEl) nameEl.textContent = file.name;
      if (sizeEl) {
        var kb = file.size / 1024;
        sizeEl.textContent = kb < 1024
          ? "· " + Math.round(kb) + " KB"
          : "· " + (kb / 1024).toFixed(1) + " MB";
      }
    };

    input.addEventListener("change", show);

    ["dragenter", "dragover"].forEach(function (t) {
      drop.addEventListener(t, function (e) {
        e.preventDefault();
        drop.classList.add("is-over");
      });
    });
    ["dragleave", "dragend", "drop"].forEach(function (t) {
      drop.addEventListener(t, function () { drop.classList.remove("is-over"); });
    });
    drop.addEventListener("drop", function (e) {
      e.preventDefault();
      if (!e.dataTransfer || !e.dataTransfer.files.length) return;
      /* DataTransfer assignment is what makes the dropped file part of the
         real form submission, not just a label change. */
      try {
        input.files = e.dataTransfer.files;
      } catch (err) {
        return;
      }
      show();
    });
  });

  /* Product gallery: thumbs switch the active slide in [data-nt-gallery] */
  [].forEach.call(document.querySelectorAll("[data-nt-gallery]"), function (gal) {
    gal.addEventListener("click", function (e) {
      var thumb = e.target.closest("[data-nt-thumb]");
      if (!thumb) return;
      var i = thumb.getAttribute("data-nt-thumb");
      [].forEach.call(gal.querySelectorAll("[data-nt-thumb]"), function (b) {
        b.setAttribute("aria-current", String(b === thumb));
      });
      [].forEach.call(gal.querySelectorAll("[data-nt-slide]"), function (s) {
        s.classList.toggle("is-active", s.getAttribute("data-nt-slide") === i);
      });
    });
  });

  /* Live card preview: any [data-nt-preview] input writes into [data-nt-bind] */
  [].forEach.call(document.querySelectorAll("[data-nt-preview]"), function (form) {
    var target = document.querySelector(form.getAttribute("data-nt-preview"));
    if (!target) return;
    form.addEventListener("input", function (e) {
      var key = e.target.getAttribute("data-nt-field");
      if (!key) return;
      var slot = target.querySelector('[data-nt-bind="' + key + '"]');
      if (slot) slot.textContent = e.target.value || slot.getAttribute("data-nt-empty") || "";
    });
    form.addEventListener("click", function (e) {
      var finish = e.target.closest("[data-nt-finish]");
      if (!finish) return;
      var value = finish.getAttribute("data-nt-finish");
      target.className = "nt-nfccard nt-nfccard--" + value;
      /* Every control bound to the same preview target stays in sync, even
         when the controls live in separate [data-nt-preview] groups. */
      var selector = form.getAttribute("data-nt-preview");
      [].forEach.call(document.querySelectorAll("[data-nt-preview]"), function (g) {
        if (g.getAttribute("data-nt-preview") !== selector) return;
        [].forEach.call(g.querySelectorAll("[data-nt-finish]"), function (b) {
          b.setAttribute("aria-pressed", String(b.getAttribute("data-nt-finish") === value));
        });
      });
    });
  });

  /* Reveal on scroll */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.style.animation = "nt-rise var(--dur-slow) var(--ease-entry) both";
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: "-40px" });
    [].forEach.call(document.querySelectorAll("[data-nt-reveal]"), function (el) { io.observe(el); });
  }

  /* Form states: native validation with inline messages + loading on submit.
     Skips forms that manage themselves (data-nt-self). */
  var MSG = { valueMissing: "Bu alan zorunlu.", typeMismatch: "Geçerli bir değer gir.", tooShort: "Biraz daha uzun olmalı.", patternMismatch: "Biçim hatalı." };
  var errFor = function (el) {
    var id = (el.id || el.name || "f").replace(/[^a-z0-9]/gi, "") + "-err", e = document.getElementById(id);
    if (!e) { e = document.createElement("span"); e.id = id; e.className = "nt-err"; e.setAttribute("role", "alert"); el.insertAdjacentElement("afterend", e); el.setAttribute("aria-describedby", id); }
    return e;
  };
  var check = function (el) {
    if (!el.willValidate) return true;
    if (el.type === "checkbox" && el.required && !el.checked) { el.setAttribute("aria-invalid", "true"); errFor(el.closest("label") || el).textContent = "Devam etmek için onay kutusunu işaretle."; return false; }
    if (el.type === "checkbox") { el.removeAttribute("aria-invalid"); var cx = (el.closest("label") || el).nextElementSibling; if (cx && cx.classList.contains("nt-err")) cx.textContent = ""; return true; }
    var ok = el.checkValidity(), msg = "";
    if (!ok) for (var k in MSG) if (el.validity[k]) { msg = el.type === "email" && k === "typeMismatch" ? "Geçerli bir e-posta adresi gir." : MSG[k]; break; }
    if (ok) { el.removeAttribute("aria-invalid"); var x = document.getElementById(el.getAttribute("aria-describedby")); if (x && x.classList.contains("nt-err")) x.textContent = ""; }
    else { el.setAttribute("aria-invalid", "true"); errFor(el).textContent = msg || el.validationMessage; }
    return ok;
  };
  [].forEach.call(document.querySelectorAll("form"), function (f) {
    if (f.hasAttribute("data-nt-self") || f.id === "nt-rs-form") return;
    var fields = [].slice.call(f.querySelectorAll("input,textarea,select")).filter(function (el) { return el.type !== "hidden"; });
    if (!fields.some(function (el) { return el.required || el.type === "email"; }) && !f.querySelector('[name="add"]')) return;
    f.setAttribute("novalidate", "");
    fields.forEach(function (el) {
      el.addEventListener("blur", function () { if (el.value) check(el); });
      el.addEventListener("input", function () { if (el.getAttribute("aria-invalid")) check(el); });
      if (el.type === "checkbox") el.addEventListener("change", function () { check(el); });
    });
    f.addEventListener("submit", function (e) {
      if (e.submitter && e.submitter.hasAttribute("formnovalidate")) return;
      var bad = fields.filter(function (el) { return !check(el); });
      if (bad.length) { e.preventDefault(); bad[0].focus(); return; }
      var btn = f.querySelector('[type="submit"]');
      if (btn) { btn.classList.add("is-loading"); btn.setAttribute("aria-busy", "true"); setTimeout(function () { btn.disabled = true; }, 0); }
    });
  });
  window.addEventListener("pageshow", function () {
    [].forEach.call(document.querySelectorAll(".is-loading"), function (b) { b.classList.remove("is-loading"); b.removeAttribute("aria-busy"); b.disabled = false; });
  });

  /* Sticky mobile CTA: appears after the first screen, hides while any real
     add-to-cart button or the footer is on screen. On product pages it
     scrolls to the add button instead of navigating. */
  var sticky = document.querySelector("[data-nt-sticky]");
  if (sticky) {
    sticky.removeAttribute("hidden");
    var visible = new Set(), past = false;
    var sync = function () { sticky.classList.toggle("is-on", past && visible.size === 0); };
    window.addEventListener("scroll", function () { past = window.scrollY > window.innerHeight * 0.6; sync(); }, { passive: true });
    if ("IntersectionObserver" in window) {
      var so = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) visible.add(x.target); else visible.delete(x.target); }); sync(); });
      [].forEach.call(document.querySelectorAll('[name="add"], .nt-footer'), function (el) { so.observe(el); });
    }
    if (sticky.hasAttribute("data-nt-sticky-product")) {
      sticky.querySelector("a").addEventListener("click", function (e) {
        var add = document.querySelector('[name="add"]');
        if (!add) return;
        e.preventDefault();
        window.scrollTo({ top: add.getBoundingClientRect().top + window.scrollY - window.innerHeight / 2, behavior: "smooth" });
        setTimeout(function () { add.focus({ preventScroll: true }); }, 500);
      });
    }
  }

  var thanks = document.querySelector("[data-nt-thanks]");
  if (thanks) { window.scrollTo(0, Math.max(0, thanks.getBoundingClientRect().top + window.scrollY - 120)); thanks.focus({ preventScroll: true }); }

  /* Cookie preferences link — only shown when Shopify's privacy banner is active */
  var cookieBtn = document.querySelector("[data-nt-cookie-prefs]");
  if (cookieBtn) {
    var tryShow = function () {
      if (cookieBtn.dataset.ready) return true;
      if (window.privacyBanner && window.privacyBanner.showPreferences) {
        cookieBtn.hidden = false; cookieBtn.dataset.ready = "1";
        cookieBtn.addEventListener("click", function () { window.privacyBanner.showPreferences(); });
        return true;
      }
    };
    if (!tryShow()) document.addEventListener("visitorConsentCollected", tryShow);
    setTimeout(tryShow, 2500);
  }

  if (window.lucide) window.lucide.createIcons();
})();
